import { show } from 'redux-modal'
import { CUSTOM_PROMOTION_MODAL } from '../constants'
import { createAction } from 'redux-actions'

export const markPromotionModalShown = createAction('CUSTOM_PROMOTION_MODAL/MARK_SHOWN')

export const showPromotionModal = (props) => dispatch => {
  dispatch(show(CUSTOM_PROMOTION_MODAL, props))
}
